<template>
  <div class="home">
    <b-container>
      <AlertForm></AlertForm>
    </b-container>
  </div>
</template>

<script>
import AlertForm from '@/components/AlertForm.vue';
export default {
  name: 'config',
  components: {
    AlertForm
  }
}
</script>
